export default function Logo({ size = 40 }) {
  return (
    <img
      src="/logo.png"
      width={size}
      height={size}
      alt="Logo Goujon Vallée"
      data-testid="brand-logo"
      className="shrink-0"
    />
  );
}
